'use strict';

/**
 * Interstitial Cart - Client-side module
 * Handles dynamic price injection for add-to-cart popup interstitial tiles.
 * Same flow as PDP: moves pre-rendered price HTML from hidden container into tile placeholders.
 *
 * @module cart/interstitialCart
 */

/** Selectors - centralized for maintainability */
var SELECTORS = {
    dynamicDataContainer: '.interstitial-dynamic-data',
    priceBlock: '.product-price-and-promotion',
    dynamicPrice: '.dynamic-product-price',
    tilePricePlaceholder: '.interstitial-tile-price'
};

/**
 * Injects promotion-aware dynamic prices from hidden container into interstitial tile placeholders.
 * Must be called after popup HTML is injected into DOM.
 *
 * @param {Object} response - Add to cart AJAX response
 * @returns {boolean} True if injection was performed
 */
function injectDynamicPrices(response) {
    if (!response || !response.showInterstitialCart) {
        return false;
    }

    var $priceBlocks = $(SELECTORS.dynamicDataContainer + ' ' + SELECTORS.priceBlock);
    if ($priceBlocks.length === 0) {
        return false;
    }

    $priceBlocks.each(function () {
        var pid = $(this).attr('data-productid');
        var $dynamicPrice = $(this).find(SELECTORS.dynamicPrice).first();

        if (pid && $dynamicPrice.length) {
            var $target = $(SELECTORS.tilePricePlaceholder + '[data-pid="' + pid + '"]');
            if ($target.length) {
                $target.empty().append($dynamicPrice);
            }
        }
        $(this).remove();
    });

    return true;
}

module.exports = {
    injectDynamicPrices: injectDynamicPrices
};
